

































import { BlockLabel, getBlockLabel, getBlockKey } from "@/models/BlockLabel";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "DeleteWithConfirmation",
  props: {
    blockType: {
      type: String,
      default: "",
    },
  },
  methods: {
    confirmRemove(dialog: any) {
      dialog.value = false;
      this.$emit("removeBlock");
    },
    getLabel: (blockType: string) => getBlockLabel(blockType),
    getClasses(): string {
      if (
        this.blockType === getBlockKey(BlockLabel.ProrataDiscount) ||
        this.blockType === getBlockKey(BlockLabel.DelayedInvoice) ||
        this.blockType === getBlockKey(BlockLabel.ExistingMembershipExemption)
      ) {
        return "remove block-without-expandable";
      }
      return "remove";
    },
  },
});
